export default {
  profileInfo: {},
  requestApplications: [],

  paymentLink: null,
  paymentList: [],

  dashboardInfo: {},
};
